module.exports = __webpack_public_path__ + "static/media/Avenir-Book-01.1a991c25.svg";